'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SpruceClassName = require('../util/SpruceClassName');

var _SpruceClassName2 = _interopRequireDefault(_SpruceClassName);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @module Inputs
 */

/**
 * @component
 *
 * `Select` is a small wrapper around [react-select](https://github.com/JedWatson/react-select).
 *
 * @prop {Boolean} [multi]
 * Toggles the between single and multi select mode.
 * Multiselect onChange will return an array to `newValue`
 *
 * @prop {boolean} [clearable]
 * @prop {boolean} [disabled]
 * @prop {boolean} [multi]
 * @prop {OnChange|OnChangeMulti} [onChange]
 * @prop {Object[]} [options]
 * @prop {string} [placeholder]
 * @prop {any} [value]
 * @prop {string} [valueKey]
 *
 * @example
 * const options = [
 *     {
 *         value: 'foo',
 *         label: 'Foo'
 *     },
 *     {
 *         value: 'bar',
 *         label: 'Bar'
 *     }
 * ]
 * return <Select onChange={(val) => doStuff(val)} options={options}/>
 */

var Select = function (_React$Component) {
    (0, _inherits3.default)(Select, _React$Component);

    function Select() {
        (0, _classCallCheck3.default)(this, Select);
        return (0, _possibleConstructorReturn3.default)(this, (Select.__proto__ || (0, _getPrototypeOf2.default)(Select)).apply(this, arguments));
    }

    (0, _createClass3.default)(Select, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                multi = _props.multi,
                onChange = _props.onChange,
                className = _props.className,
                modifier = _props.modifier,
                peer = _props.peer,
                name = _props.spruceName,
                style = _props.style,
                valueKey = _props.valueKey;


            var modifiedOnChange = multi ? function (options, meta) {
                return onChange && onChange(options.map(function (ii) {
                    return ii[valueKey];
                }), meta);
            } : function (option, meta) {
                return onChange && onChange(option && option[valueKey], meta);
            };

            return _react2.default.createElement(_reactSelect2.default, (0, _extends3.default)({}, this.props, {
                className: (0, _SpruceClassName2.default)({ name: name, modifier: modifier, className: className, peer: peer }),
                onChange: modifiedOnChange,
                style: style
            }));
        }
    }]);
    return Select;
}(_react2.default.Component);

Select.defaultProps = {
    className: '',
    modifier: '',
    peer: '',
    spruceName: 'Select',
    valueKey: 'value',
    style: {}
};
exports.default = Select;


//////////////////
// WEBPACK FOOTER
// ./~/stampy/lib/component/Select.js
// module id = 153
// module chunks = 35783957827783 114276838955818 162898551421021